import { type ComponentStyleConfig } from '@chakra-ui/react';

export const Button: ComponentStyleConfig = {
  defaultProps: {
    variant: 'primary',
    _disabled: {
      cursor: 'not-allowed',
    },
    _hover: {
      _disabled: {
        cursor: 'not-allowed',
      },
    },
  },
  variants: {
    primary: {
      background: 'primaryButton.background',
      color: 'primaryButton.color',
      borderRadius: '4px',
      _disabled: {
        background: 'primaryButton.disabledBackground',
        opacity: '30%',
      },
      _hover: {
        background: 'primaryButton.hoverBackground',
        _disabled: {
          background: 'primaryButton.disabledBackground',
          opacity: '30%',
        },
      },
      _active: {
        background: 'primaryButton.activeBackground',
      },
    },

    secondary: {
      backgroundColor: 'secondaryButton.background',
      color: 'secondaryButton.color',
      borderRadius: '4px',
      border: '1px solid',
      borderColor: 'secondaryButton.border',
      _disabled: {
        background: 'secondaryButton.disabledBackground',
        color: 'secondaryButton.disabledColor',
        opacity: '30%',
      },
      _hover: {
        background: 'secondaryButton.hoverBackground',
      },
      _active: {
        background: 'secondaryButton.activeBackground',
      },
    },

    tertiary: {
      backgroundColor: 'transparent',
      color: 'secondaryButton.color',
      borderRadius: '4px',
      border: '1px solid',
      borderColor: 'border',
      _active: {
        background: 'primaryButton.lightBackground',
        color: 'primaryButton.activeBackground',
        borderColor: 'primaryButton.background',
      },
      _hover: {
        background: 'activeBackground',
      },
    },

    text: {
      color: 'textButton.color',
      _disabled: {
        color: 'textButton.disabledColor',
        opacity: '30%',
      },
      _hover: {
        color: 'textButton.hoverColor',
      },
      _active: {
        color: 'textButton.activeColor',
      },
    },

    black: {
      backgroundColor: 'blackButton.background',
      color: 'blackButton.color',
      _disabled: {
        color: 'blackButton.disabledColor',
        background: 'blackButton.disabledBackground',
        opacity: '30%',
      },
      _hover: {
        background: 'blackButton.hoverBackground',
      },
      _active: {
        background: 'blackButton.activeBackground',
      },
    },

    filter: {
      _hover: {
        bg: 'bodyBackground',
        _active: {
          bg: 'secondaryBackground',
        },
      },
    },
    tabIndicator: {
      bg: 'transparent',
      color: 'neutralText',
      fontWeight: 'normal',
      borderRadius: 0,
      h: 'auto',
      w: 'full',
      textTransform: 'uppercase',
      px: 4,
      pt: 1,
      pb: '10px',
      borderBottom: '1px solid',
      borderColor: 'border',
      _hover: {
        bg: 'transparent',
        color: 'lighterText',
        _disabled: {
          color: 'neutralText',
        },
      },
      _active: {
        bg: 'transparent',
      },
      _disabled: {
        opacity: '40%',
        cursor: 'not-allowed',
      },
      '&[data-active], &[aria-selected=true]': {
        color: 'text',
        fontWeight: 'semibold',
        borderBottomWidth: '2px',
        borderBottomColor: 'borderActive',
        pb: '8px',
        _hover: {
          bg: 'transparent',
          color: 'text',
        },
      },
    },

    danger: {
      bg: 'danger.900',
      color: 'white',
      _hover: {
        bg: 'danger.1000',
      },
    },

    aiAssistent: {
      bg: 'gradient.aiAssistent',
      color: 'white',
      borderRadius: '4px',
      _hover: {
        bg: 'gradient.aiAssistent',
        opacity: 0.9,
        _disabled: {
          bg: 'gradient.color_spectrum',
          opacity: 0.3,
          cursor: 'not-allowed',
        },
      },
      _disabled: {
        bg: 'gradient.aiAssistent',
        opacity: '30%',
        cursor: 'not-allowed',
      },
    },
  },
};
